import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

/**
 * HOC that Handles whether or not the user is allowed to see the page.
 * @param {Array<String>} notAllowedRoles - user roles that are NOT allowed to see the page.
 * @returns {Component}
 */
export default (notAllowedRoles, companyType = '') => {
  return (WrappedComponent) => {
    const RoutesWithAuthorization = (props) => {
      const { user } = props

      // In case logged in user is not defined.
      // Usually because there is a logout action
      if (!user.authToken) {
        return <Redirect to='/' />
      }

      const { role, authToken } = user

      if (!notAllowedRoles.includes(role) && authToken && companyType !== 'OP') {
        return <WrappedComponent {...props} />
      } else {
        return <Redirect to='/dashboard' />
      }
    }

    return connect((state) => ({ user: state.user, settings: state.settings, tabs: state.tabs }))(RoutesWithAuthorization)
  }
}
